import { Column, Entity, Index, JoinColumn, ManyToOne } from 'typeorm';
import type { EntityWatcherModel } from '../interfaces';
import { BaseEntity } from './base.entity';
import { SourcingRequestEntity } from './sourcing-request.entity';
import { UserEntity } from './user.entity';

/**
 * Entity for tracking users who are watching a sourcing request.
 * Used by the notification system to send activity updates.
 */
@Index('sourcing_request_user__fk_user__id_fk', ['fkUserId'], {})
@Index('sourcing_request_user_pk', ['fkSourcingRequestId', 'fkUserId'], {
	unique: true,
})
@Entity('sourcing_request_user')
export class SourcingRequestUserEntity
	extends BaseEntity
	implements EntityWatcherModel
{
	@Column('int', { name: '_fk_sourcing_request__id', unsigned: true })
	public fkSourcingRequestId!: number;

	@Column('int', { name: '_fk_user__id', unsigned: true })
	public fkUserId!: number;

	@ManyToOne(() => UserEntity, {
		onDelete: 'CASCADE',
		onUpdate: 'RESTRICT',
	})
	@JoinColumn([{ name: '_fk_user__id', referencedColumnName: 'id' }])
	public fkUser!: UserEntity | null;

	@ManyToOne(
		() => SourcingRequestEntity,
		(sourcingRequest) => sourcingRequest.users,
		{
			onDelete: 'CASCADE',
			onUpdate: 'RESTRICT',
		},
	)
	@JoinColumn([
		{ name: '_fk_sourcing_request__id', referencedColumnName: 'id' },
	])
	public fkSourcingRequest!: SourcingRequestEntity;
}
